import api from 'api/api'
import { COIN_TYPE } from 'constants/coinTypes'
import { getMonthDate, getStringDate } from 'utils/get-string-date'

export const GET_SALES_MONITORING = '[OPERATIONS MONITORING] GET SALES MONITORING'
export const GET_CREDITS_MONITORING = '[OPERATIONS MONITORING] GET CREDITS MONITORING'
export const GET_GENERAL_MONITORING = '[OPERATIONS MONITORING] GET GENERAL MONITORING'
export const GET_SALES_BY_SELLER = "[OPERATIONS MONITORING] GET SALES BY SELLER"
export const GET_SALES_BY_MONTH = "[OPERATIONS MONITORING] GET SALES BY MONTH"
export const GET_GLOBAL_CUSTOMER_BALANCES_DETAIL = "[OPERATIONS MONITORING] GET GLOBAL CUSTOMER BALANCES DETAIL"
export const GET_GLOBAL_SUPPLIER_BALANCES_DETAIL = "[OPERATIONS MONITORING] GET GLOBAL SUPPLIER BALANCES DETAIL"

export function getSalesMonitoringAction(params = { coinTypeId: COIN_TYPE.PEN, paymentTypeId: 0, from: `${getMonthDate()}-01`, to: getStringDate() }) {
  const request = api.get('/operations-monitoring/sales-monitoring', { params })
  return (dispatch) => {
    dispatch({ type: GET_SALES_MONITORING, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SALES_MONITORING, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SALES_MONITORING, error)
    }).finally(() => {
      dispatch({ type: GET_SALES_MONITORING, payload: { loading: false } })
    })
  }
}

export function getSalesBySellerAction(year, coinTypeId, branchId = 0) {
  const request = api.get(`/operations-monitoring/sales-by-seller?year=${year}&coinTypeId=${coinTypeId}&branchId=${branchId}`)
  return (dispatch) => {
    dispatch({ type: GET_SALES_BY_SELLER, payload: { loading: true, data: [] } })
    request.then((response) => {
      dispatch({ type: GET_SALES_BY_SELLER, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SALES_BY_SELLER, error)
      dispatch({ type: GET_SALES_BY_SELLER, payload: { loading: false, data: [] } })
    })
  }
}

export function getCreditsMonitoringAction(params = { branchId: 0, coinTypeId: COIN_TYPE.PEN, from: `${getMonthDate()}-01`, to: getStringDate(), status: '' }) {
  const request = api.get('/operations-monitoring/credits-monitoring', { params })
  return (dispatch) => {
    dispatch({ type: GET_CREDITS_MONITORING, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_CREDITS_MONITORING, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_CREDITS_MONITORING, error)
    }).finally(() => {
      dispatch({ type: GET_CREDITS_MONITORING, payload: { loading: false } })
    })
  }
}

export function getGeneralMonitoringAction(params = { branchId: 0, coinTypeId: COIN_TYPE.PEN, from: `${getMonthDate()}-01`, to: getStringDate() }) {
  const request = api.get('/operations-monitoring/general-monitoring', { params })
  return (dispatch) => {
    dispatch({ type: GET_GENERAL_MONITORING, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_GENERAL_MONITORING, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_GENERAL_MONITORING, error)
    }).finally(() => {
      dispatch({ type: GET_GENERAL_MONITORING, payload: { loading: false } })
    })
  }
}

export function getSalesByMonthAction(year, coinTypeId, branchId = 0) {
  const request = api.get(`/operations-monitoring/sales-by-month?year=${year}&coinTypeId=${coinTypeId}&branchId=${branchId}`)
  return (dispatch) => {
    dispatch({ type: GET_SALES_BY_MONTH, payload: { loading: true, data: [] } })
    request.then((response) => {
      dispatch({ type: GET_SALES_BY_MONTH, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SALES_BY_MONTH, error)
      dispatch({ type: GET_SALES_BY_MONTH, payload: { loading: false, data: [] } })
    })
  }
}

export function getGlobalCustomerBalancesDetailAction(coinTypeId, branchId = 0) {
  const request = api.get(`/operations-monitoring/global-customer-balances-detail?coinTypeId=${coinTypeId}&branchId=${branchId}`)
  return (dispatch) => {
    dispatch({ type: GET_GLOBAL_CUSTOMER_BALANCES_DETAIL, payload: { loading: true, data: [] } })
    request.then((response) => {
      dispatch({ type: GET_GLOBAL_CUSTOMER_BALANCES_DETAIL, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      console.log(GET_GLOBAL_CUSTOMER_BALANCES_DETAIL, error)
      dispatch({ type: GET_GLOBAL_CUSTOMER_BALANCES_DETAIL, payload: { loading: false, data: [] } })
    })
  }
}

export function getGlobalSupplierBalancesDetailAction(coinTypeId, branchId = 0) {
  const request = api.get(`/operations-monitoring/global-supplier-balances-detail?coinTypeId=${coinTypeId}&branchId=${branchId}`)
  return (dispatch) => {
    dispatch({ type: GET_GLOBAL_SUPPLIER_BALANCES_DETAIL, payload: { loading: true, data: [] } })
    request.then((response) => {
      dispatch({ type: GET_GLOBAL_SUPPLIER_BALANCES_DETAIL, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      console.log(GET_GLOBAL_SUPPLIER_BALANCES_DETAIL, error)
      dispatch({ type: GET_GLOBAL_SUPPLIER_BALANCES_DETAIL, payload: { loading: false, data: [] } })
    })
  }
}

export const GET_SALES_DETAIL = '[OPERATIONS MONITORING] GET SALES DETAIL'

export function getSalesDetailAction(params = { branchId: 0, coinTypeId: COIN_TYPE.PEN, from: `${getMonthDate()}-01`, to: getStringDate(), search: '', page: 1, perPage: 50 }) {
  const request = api.get('/operations-monitoring/sales-detail', { params })
  return (dispatch) => {
    dispatch({ type: GET_SALES_DETAIL, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SALES_DETAIL, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SALES_DETAIL, error)
      dispatch({ type: GET_SALES_DETAIL, payload: { loading: false, data: { items: [], total: 0, totalAmount: 0 } } })
    })
  }
}